<template>
  <div id="page">
    <van-nav-bar
      title="龙虎榜"
      left-text=""
      left-arrow
      @click-left="onClickLeft()"
    >
    </van-nav-bar>
    <div>
      <!-- 前50名-->
      <van-notice-bar left-icon="volume-o" :text="text" />
      <!-- 50名之后-->
      <!-- <van-notice-bar
        left-icon="volume-o"
        text="本团排名xx名，距上一名相差xx单"
      /> -->
      <div
        class="scroll-wrapper align-center"
        style="
          height: 900px;
          background-color: rgb(255, 255, 255);
          transform: translate(0px, 0px) translateZ(0px);
        "
      >
        <div class="e-page-bg-image" style="opacity: 1; height: 900px">
          <img
            src="../assets/team1/rankLogo.jpg"
            fit="contain"
            width="100%"
            style="opacity: 1; height: 900px"
          />
        </div>
        <div
          class="page-content"
          style="width: 376px; height: 900px; overflow: hidden"
        >
          <van-row style="height: 400px;">
            <div style="height: 100%; margin-top: 430px">
              <ul class="component-answer-ranking-list-list__2yquV">
                <li
                  class="component-answer-ranking-list-item__3LSNV"
                  data-key="0"
                >
                  <div
                    class="component-answer-ranking-list-text__VLnWw"
                    style="
                      transform: rotate3d(0, 0, 1, 0deg);
                      opacity: 1;
                      border-style: solid;
                      border-width: 0px;
                      border-color: rgb(0, 0, 0);
                      border-radius: 0px;
                      width: 45%;
                      height: 19px;
                      left: 5%;
                      color: rgb(51, 51, 51);
                      font-size: 14px;
                      font-family: normal;
                      font-style: normal;
                      font-weight: 600;
                      text-align: center;
                      text-decoration: none;
                      line-height: 19px;
                      letter-spacing: 0px;
                      background-color: transparent;
                      position: absolute;
                      top: 5px;
                    "
                  >
                    团队名
                  </div>
                  <div
                    class="
                      component-answer-ranking-list-text__VLnWw
                      component-answer-ranking-list-single-ellipsis__2w3_K
                    "
                    style="
                      transform: rotate3d(0, 0, 1, 0deg);
                      opacity: 1;
                      border-style: solid;
                      border-width: 0px;
                      border-color: rgb(0, 0, 0);
                      border-radius: 0px;
                      width: 45%;
                      height: 17px;
                      left: 50%;
                      color: rgb(51, 51, 51);
                      font-size: 12px;
                      font-family: normal;
                      font-style: normal;
                      font-weight: 400;
                      text-align: center;
                      text-decoration: none;
                      line-height: 17px;
                      letter-spacing: 0px;
                      background-color: transparent;
                      position: absolute;
                      top: 6px;
                    "
                  >
                    <span class="label">名次</span>
                  </div>
                </li>
                <li
                  class="component-answer-ranking-list-item__3LSNV"
                  v-for="(item, idx) in pageList"
                  v-bind:key="idx"
                >
                  <div                   
                    class="component-answer-ranking-list-text__VLnWw"
                    style="
                      transform: rotate3d(0, 0, 1, 0deg);
                      opacity: 1;
                      border-style: solid;
                      border-width: 0px;
                      border-color: rgb(0, 0, 0);
                      border-radius: 0px;
                      width: 45%;
                      height: 19px;
                      left: 5%;
                      color: rgb(51, 51, 51);
                      font-size: 14px;
                      font-family: normal;
                      font-style: normal;
                      font-weight: 600;
                      text-align: center;
                      text-decoration: none;
                      line-height: 19px;
                      letter-spacing: 0px;
                      background-color: transparent;
                      position: absolute;
                      top: 5px;
                    "                    
                  >
                    {{ item.TeamName }}
                  </div>
                  <div
                    class="
                      component-answer-ranking-list-text__VLnWw
                      component-answer-ranking-list-single-ellipsis__2w3_K
                    "
                    style="
                      transform: rotate3d(0, 0, 1, 0deg);
                      opacity: 1;
                      border-style: solid;
                      border-width: 0px;
                      border-color: rgb(0, 0, 0);
                      border-radius: 0px;
                      width: 45%;
                      height: 17px;
                      left: 50%;
                      color: rgb(51, 51, 51);
                      font-size: 12px;
                      font-family: normal;
                      font-style: normal;
                      font-weight: 400;
                      text-align: center;
                      text-decoration: none;
                      line-height: 17px;
                      letter-spacing: 0px;
                      background-color: transparent;
                      position: absolute;
                      top: 6px;
                    "
                  >
                    <span class="label">{{ ++idx + pageSize*(currentPage-1) }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </van-row>
          <van-row style="margin-top:2%;height: 10%;">
            <!-- 分页只要 调用两个对应方法就可以 -->
            <!-- <div class="page-foot">
              <div @click="changePage(-1)" style="float:left;width:50%;">上一页</div>
              <div @click="changePage(1)" style="float:left;width:50%;">下一页</div>
            </div> -->
            <div>
              <div style="float:left;width:20%;margin-left:22%;text-aligin:center;">
                <van-button round type="primary" size="mini" @click="changePage(-1)">上一页</van-button>
              </div>
              <div style="float:left;width:20%;margin-left:22%;text-aligin:center;">
                <van-button round type="primary" size="mini" @click="changePage(1)">下一页</van-button>
              </div>
            </div>
          </van-row>
          
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Button,
  NavBar,
  Row,
  Icon,
  CountDown,
  GridItem,
  Grid,
  Divider,
  NoticeBar,
} from "vant";
export default {
  data() {
    return {
      pageSize:10,//一页默认数据量
      pageList:[],
      currentPage:1,
      text: "",      
      list: [],
    };
  },
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  created() {
    console.log("2323?");
    this.getRank();
  },
  methods: {
    onClickLeft() {
      this.$router.back(-1);
    },
    getRank() {
      var that = this;
      that.$http.get("Team/QueryTop50Team").then((res) => {
        console.log(res);
        if (res.data.Msg == "success") {
          that.list = res.data.Data.List;
          that.pageList = that.pagination(1,that.pageSize,that.list);
          that.text = res.data.Data.Text;
        }
      });
    },

    changePage(num){
      //如果是首页 点击上一页则什么也不做
      if(this.currentPage+num<=0){
        return;
      }
      var pageList = this.pagination( this.currentPage+num,this.pageSize,this.list);
      if(pageList.length>0){
        this.pageList=pageList;
        this.currentPage +=num;
      }
    },

    /* 分页函数, pageNo:页码 pageSize:每页显示的条数 array:要分页的数据 */
    pagination(pageNo, pageSize, array) {
      var offset = (pageNo - 1) * pageSize;
      return (offset + pageSize >= array.length) ? array.slice(offset, array.length) : array.slice(offset, offset + pageSize);
    }
  },
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Icon.name]: Icon,
    [CountDown.name]: CountDown,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Divider.name]: Divider,
    [NoticeBar.name]: NoticeBar,
  },
};
</script>
<style scoped>
/* html {
  background: #f12416;
} */
#page {
  width: 100%;
  height: 100%;
}
.mockTap {
  width: 280px;
  height: 280px;
  padding-top: 70px;
}
.step {
  z-index: 999;
}

.bounce-in-top {
  -webkit-animation: bounce-in-top 1.2s ease-in both;
  animation: bounce-in-top 1.2s ease-in both;
}
/* ----------------------------------------------
 * Generated by Animista on 2021-9-5 1:36:2
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation bounce-in-top
 * ----------------------------------------
 */
@-webkit-keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
    transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
    transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}
@keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
    transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
    transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}

div,
img {
  font-size: 100%;
  vertical-align: initial;
  background: transparent;
  outline: none;
}

img {
  user-select: none;
}

.cmp.cmp-image .image .inner-image {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  outline: 1px solid transparent;
}
.cmp .animate-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.cmp.cmp-image .image {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.cmp.cmp-pluginComponent > .animate-wrapper {
  overflow: visible;
}

.cmp .animate-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.plugin-container {
  position: relative !important;
  display: block !important;
  width: 100% !important;
  height: 100% !important;
}

.component-team-list-app__3ay0S {
  box-sizing: border-box;
  overflow: hidden;
  background-color: initial !important;
  border-radius: 0px !important;
}

.component-team-list-rect__2HIBd {
  position: absolute;
}
.component-team-list-rect__2HIBd {
  margin-top: 5px;
  margin-bottom: 5px;
  width: 100%;
  height: 252px;
  border-radius: 7px;
}

.component-team-list-placeholder__-bp2V {
  position: absolute;
  margin-top: 80px;
  width: 170px;
  height: 128px;
  text-align: center;
}

.component-team-list-placeholder__-bp2V,
.component-team-list-placeholder__-bp2V img {
  left: 50%;
  transform: translateX(-50%);
}

.component-team-list-placeholder__-bp2V img {
  position: relative;
  display: block;
  width: 98px;
  height: 82px;
  margin: 0;
}

.component-team-list-placeholder__-bp2V p {
  width: 100%;
  margin-top: 29px;
  color: #666;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
}

.component-team-list-progress-navigation-bar__1QbED,
.component-team-list-slider__30gT4,
.component-team-list-swiper-wrapper__1Onag {
  position: absolute;
}

.component-team-list-swiper-wrapper__1Onag {
  width: 100%;
  height: 100%;
}

.component-team-list-list__2UyMq {
  margin-top: 59px;
  margin-left: 3%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 94%;
  height: 65px;
}

.component-team-list-item__2bK-K {
  position: relative;
  width: 50px;
  height: 100%;
  list-style: none;
}

.component-team-list-button__18D8d {
  overflow: hidden;
  background: none;
  border: none;
  outline: none;
  appearance: none;
}

.component-team-list-image__2eOAP {
  object-fit: cover;
  outline: transparent solid 1px;
  backface-visibility: hidden;
}

.component-team-list-item__2bK-K div {
  white-space: nowrap;
  word-break: break-all;
}

.component-team-list-button__18D8d > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  vertical-align: middle;
}

.component-team-list-emphasize-number__1Yurg {
  margin: 0px 2px;
  color: rgb(213, 21, 21);
  font-size: 12px;
}

.cmp.cmp-countdown .countdown-wrapper {
  overflow: hidden;
  height: 100%;
  flex-wrap: nowrap;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
}

.countdownblock {
  width: 19%;
  min-width: 6px;
  height: auto;
  margin: 6px;
  padding: 1px 0;
}

.countdownblock .block-wrapper .c-num {
  display: inline-block;
  overflow: hidden;
  width: 50%;
  font-size: 27px;
}

.countdownblock .block-wrapper .c-text {
  display: flex;
  width: 100%;
  margin-top: 2px;
  font-size: 14px;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
}

.countdownblock .block-wrapper .c-num.left .flex-wrapper {
  -webkit-box-pack: end;
  justify-content: flex-end;
}

.countdownblock .block-wrapper .c-num .flex-wrapper .next-value {
  position: absolute;
  top: -100%;
  opacity: 1;
  line-height: 27px;
}

.countdownblock .block-wrapper .c-num .flex-wrapper .curr-value {
  line-height: 27px;
}

.cmp.cmp-countdown * {
  transform: translateZ(0);
}

.cmp.cmp-btn button {
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: none;
  border: none;
  outline: none;
  appearance: none;
  word-break: break-all;
}

.component-team-create-button-button__18D8d > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  vertical-align: middle;
}

.cmp.cmp-btn img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  vertical-align: middle;
}

.component-team-create-button-button__18D8d {
  overflow: hidden;
  background: none;
  border: none;
  outline: none;
  appearance: none;
}

.scroll-wrapper {
  display: flex;
  overflow: hidden;
  width: 100%;
}

.e-page-bg-image,
.e-page-bg-image img {
  position: absolute;
}
.e-page-bg-image {
  top: 0;
  left: 0;
  width: 100%;
}

/* .component-answer-ranking-list-item__3LSNV:not(:last-child) {
    border-bottom: 1px solid #eee;
} */
.component-answer-ranking-list-item__3LSNV {
  position: relative;
  height: 35px;
}
</style>